import React from "react";

const PredictionCard = ({ prediction , mobile}) => {
  return (
    <div className="app-pd flex flex-col items-center space-y-4 w-full">
      <div className="w-full h-32 bg-white app-rounded overflow-hidden">
        <img
          className="object-cover w-full h-full"
          alt={prediction.title}
          src={mobile ? prediction.app_image_url : prediction.web_image_url}
        />
      </div>
    </div>
  );
};

export default PredictionCard;

